const IdsBusineAdmin = [6]
export default {
    namespaced: true,

    state: () => ({
        user: {},
        users: [],
        busineAdmin : '',
    }),
    getters:{
        me: state => state.user || '',
        getMyBusine : state => state.user.business_id,
        isSuperAdmin : state => IdsBusineAdmin.includes(state.user.business_id),
        getBusineAdmin: state => state.busineAdmin,
    },
    mutations: {
        STORE_USER(state, user) {
            state.user = user;
        },

        STORE_USERS(state, user) {
            state.users = user
        },
        BUSINE_ADMIN(state, id) {
            state.busineAdmin = id
        },
    },

    actions: {
        setBusineAdmin({commit}, value) {
            commit('BUSINE_ADMIN', value)
        },
    },
};
